import { array, boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Scope } from '../acs/Scope';
import { RefItem as UserGroupRefItem } from '../acs/user-group/RefItem';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,
		initials: string,

		scopes: array(Scope),
		userGroups: array(UserGroupRefItem),

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
